import { Service } from "constants/external-references";

export const canAccessB2BPOSIntegration = (me, lsidIdentity) => {
    const hasRSeriesIntegration = Boolean(lsidIdentity?.accountGrants?.retail?.length);
    const hasXSeriesIntegration = Boolean(
        me?.external_references?.find((reference) => reference?.service === Service.X_SERIES)
    );

    return hasRSeriesIntegration || hasXSeriesIntegration;
};
